import { getFullUrl } from 'hubspot-url-utils';
import baseHttpClient from '../../utils/apiClient';
export const fetchAssociationSectionList = ({
  callObjectId,
  toObjectType,
  setSkipRefresh
}) => baseHttpClient.get(`${getFullUrl('app-api')}/crm/v3/objects/calls/${callObjectId}/associations/${toObjectType}`, {
  setSkipRefresh
});
export const associateObject = ({
  objectId,
  objectType,
  toObjectId,
  associationType
}) => baseHttpClient.put(`${getFullUrl('app-api')}/crm/v3/objects/${objectType}/${objectId}/associations/call/${toObjectId}/${associationType}`);
export const removeAssociationObject = ({
  objectId,
  objectType,
  toObjectId,
  associationType
}) => baseHttpClient.delete(`${getFullUrl('app-api')}/crm/v3/objects/${objectType}/${objectId}/associations/call/${toObjectId}/${associationType}`);
export const updateAssociationObject = ({
  objectId,
  objectType,
  data
}) => baseHttpClient.patch(`${getFullUrl('app-api')}/crm/v3/objects/${objectType}/${objectId}`, {
  data: {
    properties: data
  }
});